import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/family/{family_account_id}/lunch_last_deposit
export const lunchLastDeposit = async (familyAccountId: number) => {
  const response = await new Request().get(
    '/ajax/family/' + familyAccountId + '/lunch_last_deposit'
  )
  return Util.Obj.keysToCamel(response.data.last_deposit)
}
